module.exports = __webpack_public_path__ + "static/media/vapeprod.e1ae7caa.png";